import React, { FC } from 'react';
import { LoadingPage } from '@/components/LoadingPage';
import { AsyncTaskError } from '@/components/AsyncTaskError';
import { useDisplayEmployeeLimit } from '@/components/utils/display_employee_limit';
import { PaginatorWithResult } from 'jbc-front/components/SearchForm';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useQuery } from '@/hooks/graphql/useQuery';
import {
  HEALTH_CHECKUP_INSTITUTIONS,
  HealthCheckupInstitutionsQueryVariables,
  HealthCheckupInstitutionsQueryResult
} from './query';
import {
  convertSearchParamsToForm,
  convertSearchParamsToGraphQL,
  getSearchParamsFromLocation,
  convertFormToSearchParams,
  convertSearchParamsToQueryString
} from './search';
import { HealthCheckupInstitutionsTable } from './parts/HealthCheckupInstitutionsTable';
import { SearchForm } from './parts/SearchForm';

export const HealthCheckupInstitution: FC = () => {
  const location = useLocation();
  const history = useHistory();
  const [limit] = useDisplayEmployeeLimit();
  const searchParams = { ...getSearchParamsFromLocation(location), limit };

  const { data, loading, refetch } = useQuery<
    HealthCheckupInstitutionsQueryResult,
    HealthCheckupInstitutionsQueryVariables
  >(HEALTH_CHECKUP_INSTITUTIONS, {
    variables: convertSearchParamsToGraphQL(searchParams),
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true
  });
  const healthCheckupInstitutions = data?.client?.healthCheckupInstitutions?.list || [];

  return (
    <div>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">健康診断実施機関マスタ</h1>
      </div>
      <AsyncTaskError displayTypes={['health_checkup_institution_csv_import']} />
      <div className="l-contents-wrap">
        <div className="l-wrap-xxl">
          <div>
            <div className="l-breadcrumb u-mb40">
              <Link to="/settings" className="l-breadcrumb-link">
                設定
              </Link>
              <span className="l-breadcrumb-here">健康診断実施機関マスタ</span>
            </div>
            <SearchForm
              values={convertSearchParamsToForm(searchParams)}
              isLoading={loading}
              totalCount={data?.client?.healthCheckupInstitutions?.totalCount}
              onSubmit={values => {
                const { _page, ...newSearchParams } = convertFormToSearchParams(values); // reset page
                history.push({ search: convertSearchParamsToQueryString(newSearchParams) });
              }}
            />
            {loading ? (
              <LoadingPage />
            ) : !data?.client ? (
              <div className="l-wrap-xs u-pt100">
                <div className="l-box-message">
                  <p className="m-title-sub u-pt0 u-ta-c">健康診断実施機関を取得できませんでした。</p>
                </div>
              </div>
            ) : (
              <HealthCheckupInstitutionsTable
                health_checkup_institutions={healthCheckupInstitutions}
                refetch={refetch}
              />
            )}
            <PaginatorWithResult
              onClick={(page: number) =>
                history.push({ search: convertSearchParamsToQueryString({ ...searchParams, _page: String(page) }) })
              }
              limit={limit}
              count={data?.client?.healthCheckupInstitutions?.totalCount}
              page={searchParams._page}
              isLoading={loading}
              failureMessage="健康診断実施機関が見つかりませんでした"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
